import React, { FC } from 'react'
import Logo from '../../common/svg/Logo'
import { LocaleLink } from '../../common/intl/LocaleLink'
import { LocalPath } from '../../common/intl/LocalPath'
import classNames from 'classnames'

export const HeaderLogo: FC<{ className?: string }> = ({ className }) => {
  return (
    <LocaleLink to={LocalPath.Home} className={classNames('flex group', className)}>
      <Logo className="group-hover:animate-spin text-3xl" />
    </LocaleLink>
  )
}
